import { useState } from 'react';
import { IncidentRow } from './_barrel.js';


        // ===== Incident Groups =====
        // Groups the incidents into collapsible sections by category so an
        // analyst can scan the picture without scrolling 80 rows.
        function IncidentGroups({ incidents, token, openDialog, reload }) {
            // Default expanded: hostile open, off-target collapsed, others
            // expanded if small enough to be useful at a glance.
            const isHostile = (i) =>
                (i.llm_classification && i.llm_classification.startsWith('hostile_')) ||
                ['threat','doxxing','impersonation','disinformation'].includes(i.incident_type_code);
            const isOffTarget = (i) =>
                i.llm_classification === 'off_target' || i.status === 'false_positive';
            const isBreach = (i) =>
                ['breach','breach_exposure','credential_breach','data_breach'].includes(i.incident_type_code);

            // Build groups
            const groups = [
                {
                    key: 'hostile',
                    label: 'Hostile',
                    items: incidents.filter(i => isHostile(i) && !isOffTarget(i)),
                    accent: 'var(--red)',
                    defaultOpen: true,
                },
                {
                    key: 'breach',
                    label: 'Breach Exposure',
                    items: incidents.filter(i => isBreach(i)),
                    accent: 'var(--amber)',
                    defaultOpen: true,
                },
                {
                    key: 'neutral',
                    label: 'Neutral Mentions',
                    items: incidents.filter(i => !isHostile(i) && !isOffTarget(i) && !isBreach(i)),
                    accent: 'var(--gold)',
                    defaultOpen: false,
                },
                {
                    key: 'offtarget',
                    label: 'Off-Target / Archived',
                    items: incidents.filter(i => isOffTarget(i)),
                    accent: 'var(--muted)',
                    defaultOpen: false,
                },
            ].filter(g => g.items.length > 0);

            // Local expansion state per group
            const [openGroups, setOpenGroups] = useState(
                Object.fromEntries(groups.map(g => [g.key, g.defaultOpen]))
            );
            const toggle = (k) => setOpenGroups(s => ({ ...s, [k]: !s[k] }));

            // Sort each group: severity desc, then date desc
            const sevRank = (s) => ({critical:4, high:3, moderate:2, low:1}[s] || 0);
            const sortItems = (items) => [...items].sort((a, b) => {
                const sd = sevRank(b.severity) - sevRank(a.severity);
                if (sd) return sd;
                return new Date(b.detected_at) - new Date(a.detected_at);
            });

            return (
                <div>
                    {groups.map(g => {
                        const isOpen = openGroups[g.key];
                        return (
                            <div key={g.key} className="border-b border-veil last:border-b-0">
                                <div
                                    className="px-6 py-3 flex justify-between items-center cursor-pointer hover:bg-[var(--surface-2)]"
                                    onClick={() => toggle(g.key)}
                                    style={{borderLeft: `3px solid ${g.accent}`}}>
                                    <div className="flex items-center gap-3">
                                        <span className="font-display text-base" style={{color: g.accent}}>
                                            {g.label}
                                        </span>
                                        <span className="text-xs font-mono text-muted">({g.items.length})</span>
                                    </div>
                                    <span className="text-xs text-muted">{isOpen ? '▾' : '▸'}</span>
                                </div>
                                {isOpen && (
                                    <div>
                                        {sortItems(g.items).map(i => (
                                            <IncidentRow
                                                key={i.id}
                                                incident={i}
                                                token={token}
                                                onSignoff={() => openDialog('signoff', { incident: i, onSuccess: reload })}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            );
        }

export { IncidentGroups };
